import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["source", "target"]
    static values = {
        url: String,
        param: String
    }

    connect() {
        console.log("Dynamic select connected")
    }

    update() {
        const value = this.sourceTarget.value
        const url = new URL(this.urlValue, window.location.href)
        url.searchParams.append(this.paramValue, value)

        // passing current location id if exists (for edit form to exclude self)
        const locationId = this.sourceTarget.dataset.locationId
        if (locationId) {
            url.searchParams.append("location_id", locationId)
        }

        this.targetTarget.disabled = true

        fetch(url)
            .then(response => response.json())
            .then(data => {
                this.targetTarget.innerHTML = ""

                // Add default "Top Level" option
                const defaultOption = document.createElement("option")
                defaultOption.value = ""
                defaultOption.text = "Top Level (No Parent)"
                this.targetTarget.appendChild(defaultOption)

                data.forEach(item => {
                    const option = document.createElement("option")
                    option.value = item.id
                    option.text = item.name
                    this.targetTarget.appendChild(option)
                })

                this.targetTarget.disabled = false
            })
            .catch(error => {
                console.error("Error fetching options:", error)
                this.targetTarget.disabled = false
            })
    }
}
